<div class="w-full">
  <div class="relative">
    <div class="relative w-full cursor-pointer" (click)="toggleDropdown()">
      <div class="w-full h-10 px-3 border border-gray-300 bg-white rounded-md flex items-center gap-2 text-sm"
        [class.ring-2]="isOpen" [class.ring-blue-500]="isOpen" [class.ring-offset-2]="isOpen">
        @if (selectedItems.length === 0) {
        <span class="text-gray-500">{{label}}</span>
        }
        @for (item of selectedItems; track item) {
        <div class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-sm bg-blue-100 text-blue-800">
          {{ item[labelKey] }}
          <button type="button" class="hover:bg-blue-200 rounded-full p-0.5 transition-colors"
            (click)="removeItem(item, $event)">
            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        }

        <div class="ml-auto flex items-center">
          <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
    </div>

    @if (isOpen) {
    <div class="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-md" (mouseleave)="onMouseLeave()">
      @for (item of options; track item) {
      <div class="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer flex items-center justify-between"
        [class.bg-blue-50]="isSelected(item)" (click)="toggleItem(item)">
        <span>{{ item[labelKey] }}</span>
        @if (isSelected(item)) {
        <svg class="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        }
      </div>
      }
    </div>
    }
  </div>
</div>
